import React, { useState, useEffect, useRef } from "react";
import { Card, Carousel, Tooltip } from 'antd';
import Countdown from 'react-countdown';
import { FaLock } from "react-icons/fa";
import { TiLocationArrowOutline } from "react-icons/ti";
import { FaCheckCircle } from "react-icons/fa";
import addcarticon from "./addcarticon.svg"
import moment from "moment";
import { Link } from "react-router-dom";
import dateAvailability from "../../../../utils/dateAvailability";
import handleLocationClick from "../../../../utils/handleLocationClick";
import "./CardComponent.css";
import { LuFlagTriangleRight } from "react-icons/lu";
const gcpApiKey = process.env.REACT_APP_GCP_API_KEY;

const CardComponent = ({ item, showModal, addItemToCart, itemIsPresent, removeFromCart }) => {
    const cardClass = itemIsPresent ? "card-add-card-present" : "card-add-card";
    const [isLoaded, setIsLoaded] = useState(false);
    const [isInViewport, setIsInViewport] = useState(false);
    const imageRef = useRef();

    const handleImageLoad = () => {
        setIsLoaded(true);
    };

    const contentStyle = {
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsInViewport(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            }
        );

        if (imageRef.current) {
            observer.observe(imageRef.current);
        }

        return () => {
            if (imageRef.current) {
                observer.unobserve(imageRef.current);
            }
        };
    }, []);
    const displayInfo = dateAvailability(item?.Bookings, true, item);
    const badgeBookingType = displayInfo?.currentBookingType;
    // console.log("available",item?.Bookings.nextAvailableDate)
    return (
        <Card
            bordered={false}
            id="Location-cards"
            className="card-container"
            onClick={showModal}
        >

            <div
                className={
                    badgeBookingType
                        ? "card-img card-img--with-type-badge"
                        : "card-img"
                }
                id={`card-img-${item.id}`}
                ref={imageRef}
            >
                <div style={{ position: "relative" }}>
                    <Carousel effect="fade" autoplay>
                        <div className="card-img-pic">
                            <div className="card-img-overlay">
                                <button>View More</button>
                            </div>
                            {!isLoaded && (
                                <img
                                    src="./images/loaderImage.png"
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        filter: 'blur(10px)',
                                    }}
                                />
                            )}
                            {isInViewport && (
                                <img
                                    src={item.img || "./images/loaderImage.png"}
                                    onLoad={handleImageLoad}
                                    style={{ width: '100%', height: '100%' }}
                                />
                            )}
                        </div>
                    </Carousel>
                    <div
                        className={cardClass}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (!itemIsPresent) {
                                addItemToCart(item);
                            } else {
                                removeFromCart(item?._id)
                            }
                        }}
                    >

                        {itemIsPresent ? (
                            <img src={addcarticon} />
                        ) : (
                            <img src="/images/addcarticon.png" />
                        )}
                    </div>
                </div>
                <div className="card-body">
                    <a className="location" onClick={(e) => {
                        e.stopPropagation();
                        handleLocationClick(item.lat, item.lng);
                    }}>
                        {item.locations.name}
                    </a>
                </div>
                <div className="card-footer">
                    <div>
                        <p>Dimensions</p>
                        <span>
                            {item.width} {item?.typeOfMedia?.name === "Magazine" ? "Inch" : "ft"} X{" "}
                            {item.height} {item?.typeOfMedia?.name === "Magazine" ? "Inch" : "ft"}
                        </span>
                    </div>
                    <div>
                        {(() => {
                            const availability = dateAvailability(item?.Bookings, false, item);
                            const daysLeft = moment(availability?.nextAvailableDate).startOf("day").diff(moment().startOf("day"), "days");
                            const isImmediate = availability?.status === "IMMEDIATE";
                            let dotClass = "avail-dot avail-dot--green";
                            if (isImmediate || daysLeft <= 2) dotClass = "avail-dot avail-dot--red";
                            else if (daysLeft <= 7) dotClass = "avail-dot avail-dot--yellow";
                            return (
                                <>
                                    <p style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        {isImmediate ? "Available" : "Available From"}
                                        <span className={dotClass}></span>
                                    </p>
                                    <span style={isImmediate ? { fontSize: "13px", fontWeight: "700" } : {}}>{isImmediate ? "Immediately" : moment(availability?.nextAvailableDate).format("DD-MM-YYYY")}</span>
                                </>
                            );
                        })()}
                    </div>
                </div>
                <div className="card-display-status">
                    <p>Display</p>
                    <span>{displayInfo?.display || "No Campaign At Present"}</span>
                </div>
                {displayInfo?.display ? (
                    <div className="card-display-status">
                        <p>Sales Person</p>
                        <span>{displayInfo?.salesPerson || "N/A"}</span>
                    </div>
                ) : (
                    displayInfo?.status === "IMMEDIATE" && (
                        <div className="card-display-status">
                            {(() => {
                                const availableDate = moment(displayInfo?.nextAvailableDate).startOf("day");
                                const today = moment().startOf("day");
                                const days = today.diff(availableDate, "days");

                                if (days === 0) {
                                    return (
                                        <>
                                            <p>Available</p>
                                            <span>From Today</span>
                                        </>
                                    );
                                }

                                return (
                                    <>
                                        <p>Vacant From</p>
                                        <span>{days} Day{days > 1 ? "s" : ""}</span>
                                    </>
                                );
                            })()}
                        </div>
                    )
                )}

            </div>

            {/* Booking type badge: FOC / R (rotational) / B (normal) */}
            {(() => {
                const bookingType = badgeBookingType;
                if (!bookingType) return null;
                const config = {
                    foc: { label: "FOC", title: "This inventory is booked under FOC", color: "green", Icon: LuFlagTriangleRight },
                    rotational: { label: "R", title: "Rotational booking", color: "black", Icon: LuFlagTriangleRight },
                    normal: { label: "B", title: "Booked Inventory", color: "blue", Icon: LuFlagTriangleRight },
                    blocked: { label: "BLOCKED", title: "Blocked (normal)", color: "#646363", Icon: FaLock },
                    managementBlock: { label: "M", title: "Management block", color: "#646363", Icon: FaLock },
                };
                const { label, title, color, Icon } = config[bookingType] || {};
                if (!label) return null;
                return (
                    <Tooltip title={title} color="#ffcb10" placement="left">
                        <div
                            style={{
                                position: "absolute",
                                bottom: "10px",
                                right: "17px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                justifyContent: "center",
                                color,
                                fontWeight: "600",
                            }}
                        >
                            <Icon style={{ color, fontSize: "1rem", flexShrink: 0 }} />
                            {label}
                        </div>
                    </Tooltip>
                );
            })()}

        </Card>
    );
};

export default CardComponent;
